"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = require("react-dom");
exports.unstable_batchedUpdates = react_dom_1.unstable_batchedUpdates;



//////////////////
// WEBPACK FOOTER
// ./~/mobx-react-lite/lib/utils/reactBatchedUpdates.js
// module id = 1078
// module chunks = 0